<template>
  <div class="sc-upload-multiple">
    <el-upload ref="uploader" list-type="picture-card" :auto-upload="autoUpload"
      :disabled="disabled || (limit > 0 && defaultFileList.length >= limit)" :action="action" :name="name" :data="data"
      :http-request="request" v-model:file-list="defaultFileList" :show-file-list="showFileList" :accept="accept"
      :multiple="multiple" :limit="limit" :before-upload="before" :on-success="success" :on-error="error"
      :on-preview="handlePreview" :on-exceed="handleExceed" class="aj-upload-multiple"
      :class="{ 'limit-reached': limit > 0 && defaultFileList.length >= limit }">
      <slot>
        <el-icon><el-icon-plus /></el-icon>
      </slot>
      <template #tip>
        <div v-if="tip" class="el-upload__tip">{{ tip }}</div>
      </template>
      <template #file="{ file }">
        <div class="sc-upload-list-item">
          <!-- 视频文件显示视频图标和缩略图 -->
          <div v-if="isVideoFile(file)" class="el-upload-list__item-thumbnail video-thumbnail"
            @click="handlePreview(file)">
            <el-image class="thumbnail-image" :src="file.fileThumPath" fit="cover">
              <template #placeholder>
                <div class="sc-upload-multiple-image-slot">
                  Loading...
                </div>
              </template>
            </el-image>
            <div class="video-play-icon">
              <el-icon><el-icon-video-play /></el-icon>
            </div>
          </div>
          <!-- 图片文件使用原有的预览方式 -->
          <el-image v-else class="el-upload-list__item-thumbnail" :src="file.fileThumPath" fit="cover"
            :preview-src-list="preview" :initial-index="preview.findIndex(n => n == file.fileThumPath)"
            hide-on-click-modal append-to-body :z-index="9999">
            <template #placeholder>
              <div class="sc-upload-multiple-image-slot">
                Loading...
              </div>
            </template>
          </el-image>
          <div v-if="!disabled && file.status == 'success'" class="sc-upload__item-actions">
            <span class="del" @click="handleRemove(file)"><el-icon><el-icon-delete /></el-icon></span>
          </div>
          <div v-if="file.status == 'ready' || file.status == 'uploading'" class="sc-upload__item-progress">
            <el-progress :percentage="file.percentage" :text-inside="true" :stroke-width="16" />
          </div>
        </div>
      </template>
    </el-upload>
    <span style="display:none!important"><el-input v-model="value"></el-input></span>
    <el-dialog v-model="dialogVisible" title="视频预览" width="70%" custom-class="video-preview-dialog">
      <div style="width:100%;height:400px;" class="aj-dialog-video-play">
        <vue3-video-play ref="videoPlayer" height="380px" width="100%" :src="currentVideo.src" :type="currentVideo.type"
          :autoplay="true" :controls="true" :playsinline="true"
          :controlBtns="['play', 'volume', 'time', 'fullscreen']" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/config/upload"
import Sortable from 'sortablejs'
import vue3VideoPlay from 'vue3-video-play'

export default {
  components: {
    vue3VideoPlay
  },
  props: {
    modelValue: { type: [String, Array], default: "" },
    tip: { type: String, default: "" },
    action: { type: String, default: "" },
    apiObj: { type: Object, default: () => { } },
    name: { type: String, default: config.filename },
    data: { type: Object, default: () => { } },
    accept: { type: String, default: "image/gif, image/jpeg, image/png, video/mp4, video/quicktime, video/x-msvideo, video/x-ms-wmv" },
    maxSize: { type: Number, default: config.maxSizeFile },
    limit: { type: Number, default: 0 },
    autoUpload: { type: Boolean, default: true },
    showFileList: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
    onSuccess: { type: Function, default: () => { return true } }
  },
  data() {
    return {
      value: "",
      defaultFileList: [],
      dialogVisible: false,
      currentVideo: {
        src: '',
        type: ''
      }
    }
  },
  watch: {
    modelValue(val) {
      if (Array.isArray(val)) {
        if (JSON.stringify(val) != JSON.stringify(this.formatArr(this.defaultFileList))) {
          this.defaultFileList = val
          this.value = val
        }
      } else {
        if (val != this.toStr(this.defaultFileList)) {
          this.defaultFileList = this.toArr(val)
          this.value = val
        }
      }
    },
    defaultFileList: {
      handler(val) {
        this.$emit('update:modelValue', Array.isArray(this.modelValue) ? this.formatArr(val) : this.toStr(val))
        this.value = this.toStr(val)
      },
      deep: true
    },
    dialogVisible(val) {
      if (!val && this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }
    }
  },
  computed: {
    preview() {
      return this.defaultFileList.map(v => v.fileThumPath)
    }
  },
  mounted() {
    this.defaultFileList = Array.isArray(this.modelValue) ? this.modelValue : this.toArr(this.modelValue)
    this.value = this.modelValue
    if (!this.disabled && this.draggable) {
      this.rowDrop()
    }
  },
  methods: {
    /**
     * 判断文件是否为视频类型
     * @param {Object} file - 文件对象
     * @returns {Boolean} - 是否为视频文件
     */
    isVideoFile(file) {
      const videoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv'];

      // 检查文件类型
      if (file && file.type && videoTypes.some(type => file.type.includes(type))) {
        return true;
      }

      // 检查文件路径或URL是否包含视频扩展名
      if (file) {
        // 检查filePath属性
        if (file.filePath) {
          const ext = file.filePath.split('.').pop().toLowerCase();
          if (['mp4', 'mov', 'avi', 'wmv'].includes(ext)) {
            return true;
          }
        }

        // 检查URL是否包含视频缩略图特征
        if (file.url && file.url.includes('_thum.jpg')) {
          return true;
        }
      }

      return false;
    },
    /**
     * 默认值转换为数组
     * @param {String} str - 逗号分隔的URL字符串
     * @returns {Array} - 文件对象数组
     */
    toArr(str) {
      var _arr = [];
      var arr = str.split(",");
      arr.forEach(item => {
        if (item) {
          // 检查URL是否包含视频缩略图路径特征（_thum.jpg结尾）
          const isVideoThumbnail = item.includes('_thum.jpg');

          var urlArr = item.split('/');
          // 处理Windows路径分隔符
          if (urlArr.length === 1) {
            urlArr = item.split('\\');
          }
          var fileName = urlArr[urlArr.length - 1];

          // 根据文件扩展名判断文件类型
          var fileType = '';
          if (fileName) {
            // 如果是视频缩略图，去掉_thum后缀获取真实扩展名
            if (isVideoThumbnail && fileName.includes('_thum.jpg')) {
              const baseFileName = fileName.replace('_thum.jpg', '');
              const ext = baseFileName.split('.').pop().toLowerCase() || 'mp4';
              fileType = `video/${ext === 'mov' ? 'quicktime' : (ext === 'avi' ? 'x-msvideo' : (ext === 'wmv' ? 'x-ms-wmv' : ext))}`;
            } else {
              const ext = fileName.split('.').pop().toLowerCase();
              if (['mp4', 'mov', 'avi', 'wmv'].includes(ext)) {
                fileType = `video/${ext === 'mov' ? 'quicktime' : (ext === 'avi' ? 'x-msvideo' : (ext === 'wmv' ? 'x-ms-wmv' : ext))}`;
              } else if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) {
                fileType = `image/${ext === 'jpg' ? 'jpeg' : ext}`;
              }
            }
          }

          const fileObj = {
            fileName: fileName,
            fileThumPath: item,
            fileType: fileType
          };

          // 如果是视频文件，添加filePath属性
          if (fileType.includes('video/')) {
            if (isVideoThumbnail) {
              // 如果是缩略图URL，将_thum.jpg替换为原始扩展名来获取视频文件路径
              fileObj.filePath = item.replace('_thum.jpg', '.mp4');
            } else {
              // 对于直接的视频文件，确保filePath正确设置
              const ext = fileName.split('.').pop().toLowerCase();
              if (['mp4', 'mov', 'avi', 'wmv'].includes(ext)) {
                fileObj.filePath = item;
                // 确保状态设置为success，以便正确显示
                fileObj.status = 'success';
              }
            }
          }

          _arr.push(fileObj);
        }
      })
      return _arr;
    },
    //数组转换为原始值
    toStr(arr) {
      return arr.map(v => v.fileThumPath).join(",")
    },
    /**
     * 格式化数组值
     * @param {Array} arr - 文件对象数组
     * @returns {Array} - 格式化后的文件对象数组
     */
    formatArr(arr) {
      var _arr = []
      arr.forEach(item => {
        if (item) {
          // 创建基本对象
          const fileObj = {
            // 优先使用原始的fileName和fileThumPath，如果不存在则使用name和url
            fileName: item.fileName || item.name,
            fileThumPath: item.fileThumPath || item.url,
            fileType: item.fileType || item.type,
            fileId: item.fileId
          }

          // 保留视频文件的路径信息
          if (item.filePath) {
            fileObj.filePath = item.filePath
          }

          // 保留文件状态信息
          if (item.status) {
            fileObj.status = item.status
          } else if (this.isVideoFile(item)) {
            // 对于视频文件，如果没有状态，设置为success
            fileObj.status = 'success'
          }

          _arr.push(fileObj)
        }
      })
      return _arr
    },
    //拖拽
    rowDrop() {
      const _this = this
      const itemBox = this.$refs.uploader.$el.querySelector('.el-upload-list')
      Sortable.create(itemBox, {
        handle: ".el-upload-list__item",
        animation: 200,
        ghostClass: "ghost",
        onEnd({ newIndex, oldIndex }) {
          const tableData = _this.defaultFileList
          const currRow = tableData.splice(oldIndex, 1)[0]
          tableData.splice(newIndex, 0, currRow)
        }
      })
    },
    before(file) {
      // 图片类型验证
      const imageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      // 视频类型验证
      const videoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv'];
      // 文档类型验证
      const docTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/pdf', 'image/vnd.adobe.photoshop'];

      // 根据文件类型设置不同的大小限制
      let maxSize;
      if (imageTypes.includes(file.type)) {
        maxSize = 10; // 图片最大10MB
      } else if (videoTypes.includes(file.type)) {
        maxSize = 1000; // 视频最大1000MB
      } else if (docTypes.includes(file.type)) {
        maxSize = 50; // 文档最大50MB
      } else {
        this.$message.warning(`不支持的文件类型: ${file.type}`);
        return false;
      }

      const isSizeValid = file.size / 1024 / 1024 < maxSize;
      if (!isSizeValid) {
        this.$message.warning(`上传文件大小不能超过 ${maxSize}MB!`);
        return false;
      }
      return true;
    },
    /**
     * 文件上传成功处理
     * @param {Object} res - 上传响应结果
     * @param {Object} file - 文件对象
     * @returns {Boolean} - 处理结果
     */
    /**
     * 文件上传成功处理
     * @param {Object} res - 上传响应结果
     * @param {Object} file - 文件对象
     * @returns {Boolean} - 处理结果
     */
    success(res, file) {
      var response = config.parseData(res)
      // console.log(response)
      file.name = response.fileName
      file.url = response.fileThumPath
      // 确保缩略图路径正确
      file.fileThumPath = response.fileThumPath
      // 添加原始文件路径，用于视频播放
      file.filePath = response.filePath
      // 确保正确设置文件类型
      file.fileType = response.fileType ||
        (response.fileType === 'video' ? 'video/mp4' :
          `image/${file.url.split('.').pop().toLowerCase()}`)
      // 添加fileId到file对象
      file.fileId = response.fileId
      // 添加完整的文件信息对象
      Object.assign(file, response)
      // 确保最后调用父组件的onSuccess回调
      var os = this.onSuccess(res, file)
      if (os != undefined && os == false) {
        return false
      }
      this.$emit('update:modelValue', Array.isArray(this.modelValue) ? this.formatArr(this.defaultFileList) : this.toStr(this.defaultFileList))
    },
    error(err) {
      this.$notify.error({
        title: '上传文件未成功',
        message: err
      })
    },
    beforeRemove(uploadFile) {
      return this.$confirm(`是否移除 ${uploadFile.name} ?`, '提示', {
        type: 'warning',
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    handleRemove(file) {
      this.$refs.uploader.handleRemove(file)
      //this.defaultFileList.splice(this.defaultFileList.findIndex(item => item.uid===file.uid), 1)
    },
    handleExceed() {
      this.$message.warning(`当前设置最多上传 ${this.limit} 个文件，请移除后上传!`)
    },
    /**
     * 处理文件预览
     * @param {Object} uploadFile - 上传文件对象
     */
    handlePreview(uploadFile) {
      // 判断文件类型是否为视频
      if (this.isVideoFile(uploadFile)) {
        // 使用vue3-video-play组件显示视频预览
        this.dialogVisible = true

        // 确定视频源路径
        let videoSrc = uploadFile.url;

        // 如果是视频缩略图，转换为实际视频路径
        if (uploadFile.url && uploadFile.url.includes('_thum.jpg')) {
          videoSrc = uploadFile.url.replace('_thum.jpg', '.mp4');
        }
        // 如果有filePath属性，优先使用
        else if (uploadFile.filePath) {
          videoSrc = uploadFile.filePath;
        }

        this.currentVideo = {
          src: videoSrc,
          type: uploadFile.type || 'video/mp4'
        }

        // console.log('视频预览信息:', {
        //   原始文件: uploadFile,
        //   视频路径: videoSrc,
        //   视频类型: uploadFile.type || 'video/mp4'
        // });
      } else {
        // 默认图片预览方式
        window.open(uploadFile.url);
      }
    },
    request(param) {
      var apiObj = config.apiObj;
      if (this.apiObj) {
        apiObj = this.apiObj;
      }
      const data = new FormData();
      data.append(param.filename, param.file);
      for (const key in param.data) {
        data.append(key, param.data[key]);
      }
      apiObj.post(data, {
        onUploadProgress: e => {
          const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
          param.onProgress({ percent: complete })
        }
      }).then(res => {
        var response = config.parseData(res);
        // console.log(response)
        if (response.code == config.successCode) {
          param.onSuccess(res)
        } else {
          param.onError(response.msg || "未知错误")
        }
      }).catch(err => {
        param.onError(err)
      })
    }
  }
}
</script>

<style scoped>
#dPlayerVideo {
  height: 380px;
}

.aj-upload-multiple.limit-reached .el-upload--picture-card {
  display: none;
}

.el-form-item.is-error .sc-upload-multiple:deep(.el-upload--picture-card) {
  border-color: var(--el-color-danger);
}

:deep(.el-upload-list__item) {
  transition: none;
  border-radius: 0;
  --el-upload-list-picture-card-size: 96px;
}

.sc-upload-multiple:deep(.el-upload-list__item.el-list-leave-active) {
  position: static !important;
}

.sc-upload-multiple:deep(.el-upload--picture-card) {
  border-radius: 0;
  --el-upload-picture-card-size: 96px;
}

.sc-upload-multiple:deep(.el-upload--picture-card.is-disabled) {
  display: none;
}

.sc-upload-list-item {
  width: 100%;
  height: 100%;
  position: relative;
}

.sc-upload-multiple .el-image {
  display: block;
}

.sc-upload-multiple .el-image:deep(img) {
  -webkit-user-drag: none;
}

.sc-upload-multiple-image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
}

.sc-upload-multiple .el-upload-list__item:hover .sc-upload__item-actions {
  display: block;
}

/* 视频缩略图样式 */
.video-thumbnail {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow: hidden;
}

.video-thumbnail .thumbnail-image {
  width: 100%;
  height: 100%;
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  z-index: 1;
}

.video-thumbnail:hover .video-play-icon {
  background-color: rgba(0, 0, 0, 0.7);
}

.sc-upload__item-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: none;
}

.sc-upload__item-actions span {
  display: flex;
  justify-content: center;
  align-items: center;
  ;
  width: 25px;
  height: 25px;
  cursor: pointer;
  color: #fff;
}

.sc-upload__item-actions span i {
  font-size: 12px;
}

.sc-upload__item-actions .del {
  background: #F56C6C;
}

.sc-upload__item-progress {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: var(--el-overlay-color-lighter);
}

.el-upload-list--picture-card .el-progress {
  width: 96px;
}

/* 视频预览弹窗样式 */
:deep(.video-preview-modal) {
  width: 80%;
  max-width: 800px;
}

:deep(.video-preview-modal .el-message-box__content) {
  padding: 10px;
}
</style>
